<template>
  <div class="number-input-container mb-3">
    <label>
      <question-display :question="question" customClass="header-number-input"></question-display>
    </label>
    <input
      type="number"
      v-model="inputValue"
      :placeholder="question.placeholder || ''"
      class="form-control"
      min="0"
      @input="handleInput"
      @paste="handlePaste"
    />
    <small v-if="showValidation && !isValidInput()" class="text-danger">{{ errorMsg }}</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService';
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
    QuestionDisplay
  },
  props: {
    question: Object,
    showValidation: Boolean
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || '',
      errorMsg: ''
    };
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;

      // Prevent typing negative numbers
      if (value.startsWith('-')) {
        value = '';
      }

      // Convert to number or empty string
      if (value === '') {
        this.inputValue = '';
      } else {
        const numericValue = Number(value);
        this.inputValue = numericValue < 0 ? '' : numericValue;
      }

      surveyService.setAnswer(this.question.id, this.inputValue);
      this.$emit('input', this.inputValue);
    },
    handlePaste(event) {
      const pastedValue = event.clipboardData.getData('text');
      const numericPastedValue = Number(pastedValue);

      if (numericPastedValue < 0) {
        event.preventDefault(); // Prevent pasting negative numbers
        this.inputValue = ''; // Optionally clear the input
        surveyService.setAnswer(this.question.id, this.inputValue);
        this.$emit('input', this.inputValue);
      }
    },
    isValidInput() {
      this.errorMsg = '';

      if (this.question.required && (this.inputValue === '' || this.inputValue === null)) {
        this.errorMsg = 'This field is required.';
        return false;
      }

      if (this.inputValue !== '' && this.inputValue < 0) {
        this.errorMsg = 'Value must be a positive number.';
        return false;
      }

      // Optional: pattern validation for numbers (if needed)
      if (this.question.validators?.pattern) {
        try {
          const regex = new RegExp(this.question.validators.pattern);
          if (!regex.test(this.inputValue.toString())) {
            this.errorMsg = this.question.validators['error-msg'] || 'Invalid number format.';
            return false;
          }
        } catch (e) {
          console.warn('Invalid regex pattern:', e);
          this.errorMsg = 'Validation error.';
          return false;
        }
      }

      return true;
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || '';
    }
  }
};
</script>

<style scoped>
  /* Remove spinner arrows in number input (Chrome, Safari, Edge) */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Remove spinner arrows in Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
